var exports = {
  "z": "x1cb7f6e3--01e900--root",
};

module.exports = exports;
